import {
  developerLogBodySchema,
  developerLogEntrySchema,
} from "@redotech/developer-log-common/entry";
import * as z from "zod";

export const getDeveloperLog = {
  name: "getDeveloperLog" as const,
  input: z.object({ id: z.string() }),
  output: z.object({
    entry: developerLogEntrySchema,
    /** `null` when no body was stored, or it has expired after 30 days. */
    body: developerLogBodySchema.nullable(),
  }),
};
